import React, { FunctionComponent, SVGProps } from 'react';
import styled from 'styled-components';

interface FilterIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  invertedTheme?: boolean;
}

const FilterIcon: FunctionComponent<FilterIconProps> = ({
  className,
  invertedTheme,
  ...props
}) => {
  return (
    <svg
      className={`${className} ${invertedTheme ? 'inverted' : ''}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        className="circle"
        d="M12,0h0c6.63,0,12,5.37,12,12h0c0,6.63-5.37,12-12,12h0C5.37,24,0,18.63,0,12H0C0,5.37,5.37,0,12,0Z"
      />
      <path
        className="path"
        d="M13.15,12.02v3.7c0,.11-.03,.21-.08,.3-.05,.09-.13,.17-.22,.21l-1.46,.72c-.06,.03-.13,.05-.2,.04-.07,0-.14-.03-.19-.06-.06-.04-.11-.09-.14-.15-.03-.06-.05-.13-.05-.21v-4.55c0-.45-.16-.89-.46-1.22l-2.72-3.08c-.06-.06-.11-.13-.13-.22-.02-.08-.01-.17,.02-.25,.03-.08,.09-.15,.16-.19,.07-.04,.15-.06,.24-.06h8.13c.08-.01,.17,0,.25,.05,.07,.04,.13,.11,.17,.19,.03,.08,.04,.17,.02,.26-.02,.09-.07,.16-.14,.22l-2.76,3.13c-.27,.32-.43,.74-.43,1.17Z"
      />
    </svg>
  );
};

export default styled(FilterIcon)`
  width: 24px;
  height: 24px;

  .circle {
    fill: ${({ theme }) => theme.colors.inputBackgroundAlternateDark};
  }

  .path {
    fill: ${({ theme }) => theme.colors.primary};
  }

  &.inverted {
    .circle {
      fill: ${({ theme }) => theme.colors.primaryHover};
    }

    .path {
      fill: ${({ theme }) => theme.colors.differentBackground};
    }
  }
`;
